import { BookingBase, BookingView, SessionView } from "../../firestore/Types/BookingSchema";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { Calendar } from "../../components/Calendar/Calendar";
import { LabelText } from "../../components/Common/LabelText";
import { useCallback, useEffect, useState } from "react";
import { VerifyLoggedIn } from "./VerifyLoggedIn";
import { NewBookingView } from "../../firestore/Types/NewBookingSchema";
import { CancelBooking, CancelNewBooking, CancelSession, ConfirmBooking, GetAllNewBookings, GetBookingsForUser, GetSession, GetSessionsForUser, ReOpenSession, UpdateBookingNotes, UpdateSessionNotes } from "../../firestore/Functions/bookingFunctions";
import { useAuth } from "../../contexts/auth/AppAuthContext";
import { CalendarBooking } from "../../components/Calendar/CalendarBooking";
import { CalendarSession } from "../../components/Calendar/CalendarSession";
import { get15minuteIntervals } from "../../components/Calendar/CalendarHelpers";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { convertToBinary, getDurationText, getTimeSlotFromAndTo } from "../../Utils/TimeSlotUtils";
import { CalendarNewRequest } from "../../components/Calendar/CalendarNewRequest";
import { TimeSlotsPretty } from "../../components/Calendar/TimeSlotsPretty";
import { Combo } from "../../components/Common/Combo";
import { Roles } from "../../firestore/Types/PermissionSchema";
import { StatusTag, StatusTagColor, TagSize } from "../../components/Account/StatusTag";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion, faEnvelope, faHourglassHalf } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { BookingGuide } from "../../components/UserGuide/BookingGuide";
import { SessionGuide } from "../../components/UserGuide/SessionGuide";
import { RequestGuide } from "../../components/UserGuide/RequestGuide";
import { useLoggedIn } from "../../contexts/auth/LoggedInContext";
import { Button } from "../../components/Common/Button";

export function UserCalendar() {

    const [newBookings, setNewBookings] = useState<NewBookingView[]>([]);
    const [bookings, setBookings] = useState<BookingView[]>([]);
    const [sessions, setNewSessions] = useState<SessionView[]>([]);
    const { currentUser, permission } = useAuth();
    const minuteIntervals96 = get15minuteIntervals();
    const [showPlanningPanel, setShowPlanningPanel] = useState(true);
    const [showInfoPanel, setShowInfoPanel] = useState(false);
    const [showBooking, setShowBooking] = useState(true);

    const [showBookingGuide, setShowBookingGuide] = useState(false);
    const [showSessionGuide, setShowSessionGuide] = useState(false);
    const [showRequestGuide, setShowRequestGuide] = useState(false);
    const [showConfirmCancelBookingPopup, setShowConfirmCancelBookingPopup] = useState(false);

    const [info, setInfo] = useState<BookingBase>();
    const [infoBooking, setInfoBooking] = useState<BookingView>();
    const [infoSession, setInfoSession] = useState<SessionView>();
    const [infoNewRequest, setInfoNewRequest] = useState<NewBookingView>();
    const [infoType, setInfoType] = useState("");
    const [requestedTimeSlots, setRequestedTimeSlots] = useState(0);
    const [requestedToTimeSlots, setRequestedToTimeSlots] = useState("");

    const [confirmBookingDay, setConfirmBookingDay] = useState("");
    const [confirmBookingTimeIndex, setConfirmBookingTimeIndex] = useState(-1);
    const [calendarWeek , setCalendarWeek] = useState(0);

    const navigate = useNavigate();
    const { pendingRequests } = useLoggedIn();
    const { subjects: subjectNames, setNewToast } = useUtility();

    const startofWeek = moment().startOf("isoWeek").add(calendarWeek, "weeks"); // Assuming week starts on Monday
    
    const endofWeek = moment().endOf("isoWeek").add(calendarWeek, "weeks"); // Assuming week starts on Monday

    const filteredSessions = sessions.filter((session) => {
        const sessionDate = moment(session.SessionTimeStamp.toDate());
        return sessionDate.isBetween(startofWeek, endofWeek) 
    });

    const getSubjectName = (subjectID: string) => {
        // Get subject name from subject ID
        for (const subject of subjectNames) {
            if (subject.Id === subjectID) {
                return subject.SubjectName;
            }
        }
        return "";
    }
    function onCalendarClick(s: SessionView | BookingView, itype: string) {
        if (itype === "session") {
            onCalendarSessionClick(s as SessionView);
        } else if (itype === "booking") {
            onCalendarBookingClick(s as BookingView);
        }
    }
    function onCalendarSessionClick(s: SessionView): void {
        setShowInfoPanel(true);
        setInfoSession(s);
        setInfo(s);
        setInfoType("session");
    }

    function onCalendarBookingClick(s: BookingView): void {
        setShowInfoPanel(true);
        setInfoBooking(s);
        setInfo(s);
        setInfoType("booking");

    }
    function onCalendarNewRequestClick(s: NewBookingView) {
        setShowInfoPanel(true);
        setInfoNewRequest(s);
        setInfoType("request");

    }
    const handleNextWeek = () => {
        if (calendarWeek >= 4) {
            return;
        }
        setCalendarWeek(calendarWeek + 1);
    }

    const handlePreviousWeek = () => {
        if (calendarWeek <= 0) {
            return;
        }
        setCalendarWeek(calendarWeek - 1);
    }

    const renderBookings = () => {
        return (<>
            <div className="text-center cal-header">List of Bookings <span><button onClick={handleShowBookingGuide}><FontAwesomeIcon icon={faCircleQuestion} className="hover:text-blue-500"/></button></span></div>
            {bookings.map((booking, index) => (
                <CalendarBooking key={index} onClick={onCalendarBookingClick} showDay={true} booking={booking} />
            ))}
        </>)
    }
    const renderRequests = () => {
        // change to requests
        return (<>
            <div className="text-center cal-header">Pending Requests <span><button onClick={handleShowRequestGuide}><FontAwesomeIcon icon={faCircleQuestion} className="hover:text-blue-500"/></button></span></div>
            <div >
                {newBookings.map((newBooking, index) => (
                    <CalendarNewRequest key={index} onClick={onCalendarNewRequestClick} newBooking={newBooking} />
                ))}
            </div>
        </>)
    }
    const renderSessions = () => {
        // change to requests
        return (<>
            <div className="text-center cal-header">List of Sessions <span><button onClick={handleShowSessionGuide}><FontAwesomeIcon icon={faCircleQuestion} className="hover:text-blue-500"/></button></span></div>
            <div className="w-full relative mb-2">
                <div className="flex flex-row mx-auto border border-1 rounded-xl max-w-[400px] leading-3 max-h-7">
                    <div className="cal-header text-center max-w-6 pl-1"><div className="back-button-sm leading-6" onClick={handlePreviousWeek}></div></div>
                    <div className="text-xs text-center grow pt-1 border border-t-0 border-b-0 mx-3">{startofWeek.format("MMM Do YYYY")} - {endofWeek.format("MMM Do YYYY")}</div>
                    <div className="cal-header text-center max-w-6 pr-1"><div className="forward-button-sm leading-6" onClick={handleNextWeek}></div></div>
                </div>
            </div>
            {filteredSessions.length === 0 ? 
                <div className="flex flex-col mx-auto mt-10 ">
                    <FontAwesomeIcon icon={faHourglassHalf} fontSize="30px" color="grey"/>
                    <div className="cal-header w-[400px] text-center mt-4">Sessions for this week has not been generated or you dont have any bookings yet!</div>
                </div>
            : <></>}
            {filteredSessions.map((session, index) => (
                <CalendarSession key={index} onClick={onCalendarSessionClick} session={session} showDay={true} />
            ))}
        </>)
    }

    const handleShowBookingGuide = () => {
        setShowBookingGuide(true);
    }
    const handleShowSessionGuide = () => {
        setShowSessionGuide(true);
    }
    const handleShowRequestGuide = () => {
        setShowRequestGuide(true);
    }
    const handleShowConfirmCancelBookingPopup = () => {
        setShowConfirmCancelBookingPopup(true);
    }
    const handleCloseBookingGuide = () => {
        setShowBookingGuide(false);
    }
    const handleCloseSessionGuide = () => {
        setShowSessionGuide(false);
    }
    const handleCloseRequestGuide = () => {
        setShowRequestGuide(false);
    }
    const handleCloseConfirmCancelBookingPopup = () => {
        setShowConfirmCancelBookingPopup(false);
    }
    const setPlanningPanel = () => {
        setShowPlanningPanel(true);
    }
    const setPendingRequestsPanel = () => {
        setShowPlanningPanel(false);
    }

    const onClickShowBooking = () => {
        setShowBooking(true);
    }
    const onClickShowSession = () => {
        setShowBooking(false);
    }

    const handleMessageNewRequestUser = () => {
        if (permission.Role === Roles.User) {
            navigate(`/messages/?userId=${infoNewRequest?.TutorId}`);
        } else if (permission.Role === Roles.Tutor) {
            navigate(`/messages/?userId=${infoNewRequest?.StudentId}`);
        }
    }

    const handleMessageInfoUser = () => {
        if (permission.Role === Roles.User) {
            navigate(`/messages/?userId=${info?.TutorId}`);
        } else if (permission.Role === Roles.Tutor) {
            navigate(`/messages/?userId=${info?.StudentId}`);
        }
    }

    function bookingIsShowingCSS() {
        if (showBooking) {
            return "";
        } else {
            return " cal-filter-grayed";
        }
    }

    function sessionIsShowingCSS() {
        if (showBooking) {
            return " cal-filter-grayed";
        } else {
            return "";
        }
    }

    const handleConfirmBooking = async () => {
        if (confirmBookingDay === "" || confirmBookingTimeIndex === -1 || confirmBookingTimeIndex > 95) {
            return;
        }
        await ConfirmBooking(infoNewRequest?.Id ?? "", confirmBookingTimeIndex, confirmBookingDay, "").catch((error) => {
            setNewToast({ title: "Error", message: error.message, toastType: "error" });
        });
        await refreshNewBookings();
        await refreshSessions();
        await refreshBookings();
        resetInfo();
    }

    const handleCancelBooking = async () => {
        await CancelBooking(infoBooking?.Id ?? "").catch(
            (error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
            }
        );
        await refreshBookings();
        resetInfo();
        handleCloseConfirmCancelBookingPopup();
    }

    const handleCancelSession = async () => {
        await CancelSession(infoSession?.Id ?? "").catch(
            (error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
            }
        );
        await refreshSessions();
        const session = await GetSession(infoSession?.Id ?? "");
        setInfoSession(session);
    }

    const handleReOpenSession = async () => {
        await ReOpenSession(infoSession?.Id ?? "").then(
            async () => {
                await refreshSessions();
                const session = await GetSession(infoSession?.Id ?? "");
                setInfoSession(session);
                showToastMessage("Session Reopened", "Session has been reopened!", "success");
            }
        ).catch(
            (error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
            }
        );
        
    }

    const handleChangeNotes = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (info) {
            setInfo({ ...info, Notes: event.target.value });
        }
    }

    const handleSaveNotes = async () => {
        if (!info) {
            return;
        }
        if (infoType === "session") {
            await UpdateSessionNotes(infoSession?.Id ?? "", info.Notes ?? "").catch(
                (error) => {
                    setNewToast({ title: "Error", message: error.message, toastType: "error" });
                }
            );
        } else if (infoType === "booking") {
            await UpdateBookingNotes(infoBooking?.Id ?? "", info.Notes ?? "").catch(
                (error) => {
                    setNewToast({ title: "Error", message: error.message, toastType: "error" });
                }
            );
        }
        await refreshSessions();
    }
    //toast functions
    const showToastMessage = (title: string, message: string, toastType: string) => {
        setNewToast({ title: title, message: message, toastType: toastType as "error" | "success" | "warning" });
    }

    const renderPlanningPanel = () => {
        return (
        <>
            <div className="grid grid-cols-2">
                <div onClick={setPlanningPanel} className="cursor-pointer"> <div className="text-center cal-header pt-2">Planning</div> {(showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
                    <div onClick={setPendingRequestsPanel} className="cursor-pointer"> <div className="text-center cal-header pt-2 flex flex-col"><div className="flex flex-row mx-auto">Pending Requests{pendingRequests !== 0 && <span>  <div className="notification-circle"> {pendingRequests}</div></span>}</div></div> {(!showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
            </div>
            <div className="flex flex-row p-4 h-[50px]">
                {showPlanningPanel ? 
                <div className="flex flex-row grow">
                        <div className={"cal-booking flex flex-col m-1 p-1 px-2 text-xs h-6 grow text-center " + bookingIsShowingCSS()} onClick={onClickShowBooking}>{bookings.length} Booking{bookings.length > 1 ? "s" : ""}</div>
                        <div className={"cal-session flex flex-col m-1 p-1 px-2 text-xs h-6 grow text-center " + sessionIsShowingCSS()} onClick={onClickShowSession}>{sessions.length}  Session{sessions.length > 1 ? "s" : ""}</div>
                    </div>
                    : <></>}
            </div>
            <div className="grow flex flex-col p-2 planning overflow-y-auto">
                {(showPlanningPanel && showBooking) ? renderBookings() : <></>}
                {(showPlanningPanel && !showBooking) ? renderSessions() : <></>}
                {(!showPlanningPanel) ? renderRequests() : <></>}
            </div>
        </>)
    }
    const resetInfo = () => {
        setShowInfoPanel(false);
    }
    function getRequestDays() {
        var requestDays = [];
        requestDays.push({ Text: "", Value: " " });
        if (infoNewRequest?.TimeSlotMonday !== 0) {
            requestDays.push({ Text: "Monday", Value: "Monday" });
        }
        if (infoNewRequest?.TimeSlotTuesday !== 0) {
            requestDays.push({ Text: "Tuesday", Value: "Tuesday" });
        }
        if (infoNewRequest?.TimeSlotWednesday !== 0) {
            requestDays.push({ Text: "Wednesday", Value: "Wednesday" });

        }
        if (infoNewRequest?.TimeSlotThursday !== 0) {
            requestDays.push({ Text: "Thursday", Value: "Thursday" });
        }

        if (infoNewRequest?.TimeSlotFriday !== 0) {
            requestDays.push({ Text: "Friday", Value: "Friday" });
        }
        if (infoNewRequest?.TimeSlotSaturday !== 0) {
            requestDays.push({ Text: "Saturday", Value: "Saturday" });
        }
        if (infoNewRequest?.TimeSlotSunday !== 0) {
            requestDays.push({ Text: "Sunday", Value: "Sunday" });
        }
        return requestDays;
    }

    function getRequestTime(){
        var requestTime = [];
        requestTime.push({ Text: "", Value: " " });
        var timeSlot48 = convertToBinary(requestedTimeSlots);
        for (var i = 0; i < timeSlot48.length; i++) {
            if (timeSlot48[i] === "1") {
                requestTime.push({ Text: minuteIntervals96[(i * 2)], Value: (i * 2) + "" });
                requestTime.push({ Text: minuteIntervals96[((i * 2) + 1)], Value: ((i * 2) + 1) + "" });
            }
        }
        return requestTime;
    }

    function onRequestDayChange(day: string): void {
        if (day === "Monday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotMonday ?? -1)
        } else if (day === "Tuesday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotTuesday ?? -1)
        } else if (day === "Wednesday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotWednesday ?? -1)
        } else if (day === "Thursday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotThursday ?? -1)
        } else if (day === "Friday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotFriday ?? -1)
        } else if (day === "Saturday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotSaturday ?? -1)
        } else if (day === "Sunday") {
            setRequestedTimeSlots(infoNewRequest?.TimeSlotSunday ?? -1)
        } else {
            return;
        }
        setConfirmBookingDay(day);
    }

    function onRequestTimeSlotChange(timeIndex: string): void {
        if (timeIndex === "") {
            setRequestedToTimeSlots("")
            setConfirmBookingTimeIndex(-1);
        } else {
            const startTimeIndex = Number(timeIndex);
            setConfirmBookingTimeIndex(Number(startTimeIndex));
            var endTime = Number(startTimeIndex) + (infoNewRequest?.Duration ? (infoNewRequest?.Duration * 2) : 0);
            setRequestedToTimeSlots(" - " + minuteIntervals96[endTime]);
        }
    }

    function toTimeSlot() {
        return requestedToTimeSlots;
    }

    const cancelRequest = async () => {
        await CancelNewBooking(infoNewRequest?.Id ?? "").catch(
            (error) => {
                setNewToast({ title: "Error", message: error.message, toastType: "error" });
            }
        );
        await refreshNewBookings();
        resetInfo();
        showToastMessage("Request Cancelled", "Request was successfully cancelled!", "success");
    }

    const confirmCancelBookingPopup = () => {
        return (
            <div className="relative z-10 w-[80%] mx-[10%] py-20"
                role="dialog"
                aria-modal="true">
                <div className="fixed inset-0 bg-gray-300 bg-opacity-75 transition-all backdrop-blur-sm"></div>
                <div className="flex justify-center px-2 py-12 text-center ">
                    <div className="fixed rounded-2xl bg-white text-black text-left shadow-xl transition-all p-4">
                        <div className="flex justify-end">
                            <button onClick={handleCloseConfirmCancelBookingPopup}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                        d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="relative">
                            <div className="flex justify-center gap-4 mt-4 p-4">
                                <p>note: deleting a booking will not suspend all subsequent sessions, please suspend them individually on the sessions page</p>
                            </div>
                        </div>
                        <div className="flex justify-center gap-4 mt-4">
                            <button className="primary-button" onClick={handleCloseConfirmCancelBookingPopup}>Close</button>
                            <Button onClick={handleCancelBooking}>Confirm</Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderInfo = () => {
        // should be if booking id to show bottom part
        return (<>
            <div className="flex flex-row p-2">
                <div className="back-button" onClick={resetInfo}></div>
                {(infoType === "request" ? <div className="grow text-center cal-header">{(permission.Role === Roles.User) ? "Pending Request" : "New Request"}</div> : <div className="grow text-center cal-header p-2">{(infoType === "booking" ? <>{info?.Day} {(info?.TimeSlotIndex96 ? minuteIntervals96[info?.TimeSlotIndex96] : "")}</> : <>{infoSession?.SessionTimeStamp.toDate().toDateString()}</>)}</div>
                )}
                {(infoType === "request" ? <div className="m-1"><div className="cal-new-request-nohover cal-time w-[100px] text-center">New Request</div></div> :
                    (infoType === "session" ? <div className="m-1"><div className="cal-session-nohover cal-time w-[100px] text-center">Session</div></div> :
                        <div className="m-1"><div className="cal-booking-nohover cal-time w-[100px] text-center">Booking</div></div>))}

            </div>
            <div className="flex flex-col pl-4">
                <div className="flex flex-row">
                    <div className="flex flex-row">
                        {(infoType === "request") ?
                            <>
                                {(permission.Role === Roles.User) ? <LabelText label={"Tutor Name"} value={infoNewRequest?.TutorName}></LabelText> : <></>}
                                {(permission.Role === Roles.Tutor) ? <LabelText label={"Student Name"} value={infoNewRequest?.StudentName}></LabelText> : <></>}
                                <div className="p-4 ml-4"> <button className="primary-button" onClick={handleMessageNewRequestUser}><FontAwesomeIcon icon={faEnvelope} title="Message" /></button></div>
                            </> :
                            <>
                                {(permission.Role === Roles.User) ? <LabelText label={"Tutor Name"} value={info?.TutorName}></LabelText> : <></>}
                                {(permission.Role === Roles.Tutor) ? <LabelText label={"Student Name"} value={info?.StudentName}></LabelText> : <></>}
                                <div className="p-4 ml-4"> <button className="primary-button" onClick={handleMessageInfoUser}><FontAwesomeIcon icon={faEnvelope} title="Message"/></button></div>
                            </>
                        }
                    </div>
                    {/*{(infoType !== "request") ?*/}
                    {/*    <div className="grow flex flex-row-reverse pr-4">*/}
                    {/*        <LabelText label={"Status"} value={"Live!"}></LabelText>*/}
                    {/*    </div> : <></>}*/}
                </div>
                {(infoType === "request") ?
                    <>
                        <LabelText label={"Subject"} value={getSubjectName(infoNewRequest?.SubjectId ?? "") ?? ""}></LabelText>
                     
                    </> :
                    <>
                        <LabelText label={"Subject"} value={getSubjectName(info?.SubjectId ?? "") ?? ""}></LabelText>
                        <div className="flex flex-row">
                            <LabelText label={"Time Slot"} value={info?.Day + " " + getTimeSlotFromAndTo(info?.TimeSlotIndex96 ?? -1, info?.Duration48 ?? 0)}></LabelText>
                            <div className="ml-6"> <LabelText label={"Duration"} value={getDurationText(info?.Duration48 ?? -1)}></LabelText></div>
                        </div>
                    </>
                }
            </div>

            {(infoType !== "request") ?
                <div className="flex flex-col m-4 grow">
                    <label className="cal-header">
                        <span>Shared Notes</span>
                    </label>
                    {permission.Role === Roles.Tutor ? 
                        <textarea className="basic-form-box grow" name="messageText" placeholder="" value={info?.Notes} onChange={handleChangeNotes} ></textarea>
                        :
                        <textarea className="basic-form-box grow" name="messageText" placeholder="" value={info?.Notes} readOnly></textarea>
                    }
                    {permission.Role === Roles.Tutor && <div className="flex flex-row-reverse mt-2">
                        <button className="primary-button" onClick={handleSaveNotes}>Save</button>
                    </div>}
                </div>
                :

                <div className="flex flex-col m-4 grow">
                    <div className="flex flex-row gap-4">
                        <LabelText label={"Duration"} value={((infoNewRequest?.Duration ?? 0 )/ 2) + "hrs"}></LabelText>
                        <LabelText label={"Occurance"} value={infoNewRequest?.IsRecurring ? "Weekly " : "One Time Session"}></LabelText>
                    </div>
                    <TimeSlotsPretty title={"Requested times"} newRequest={infoNewRequest}></TimeSlotsPretty>
                    {(permission.Role === Roles.Tutor) && 
                    <> 
                        <div className="cal-header">
                            Confirm Booking/Session
                        </div>
                        <div className="grid grid-cols-4 gap-2">
                            <Combo label={"Day"} name={"requestday"} items={getRequestDays()} onUserChange={onRequestDayChange}></Combo>
                            <Combo label={"Time"} name={"requesttime"} items={getRequestTime()} onUserChange={onRequestTimeSlotChange}></Combo>
                            <div className="mt-9">
                                <div className="basic-form-label">{toTimeSlot()}</div>
                            </div>

                            <div className="flex flex-row-reverse mt-8">
                                <div>
                                    <Button className="primary-button" onClick={handleConfirmBooking}>Save</Button>
                                </div>
                            </div>
                        </div>
                    </>}
                </div>
            }
            {(infoType === "request") &&
                <div className="flex flex-row-reverse border border-r-0 border-l-0 border-b-0 pl-4 pt-2">
                    <div className="p-4"> <Button onClick={cancelRequest}>Cancel Request</Button></div>
                    <div className="cal-header p-6"></div>
                </div>
            }

            {infoType === "session" &&
                <div className="flex flex-row-reverse border border-r-0 border-l-0 border-b-0 pl-4 pt-2">
                    {infoSession?.TutorCanceled || infoSession?.StudentCanceled ?
                        <>
                            { ((infoSession.TutorCanceled && permission.Role === Roles.Tutor) || (infoSession.StudentCanceled && permission.Role === Roles.User)) && <div className="p-4"> <button className="primary-button" onClick={handleReOpenSession}>Reinstate Session</button></div>}
                            <div className="cal-header p-4"><StatusTag statusText="This session has been suspended" statusTagColor={StatusTagColor.Yellow} tagSize={TagSize.Small}/></div>
                        </>
                        : 
                        <>
                            <div className="p-4"> <Button onClick={handleCancelSession}>Cancel Session</Button></div>
                            <div className="cal-header p-6">Session will go ahead!</div>
                        </>
                    }
                </div>
            }

            {infoType === "booking" &&
                <div className="flex flex-row-reverse border border-r-0 border-l-0 border-b-0 pl-4 pt-2">
                    <div className="p-4"> <button className="primary-button" onClick={handleShowConfirmCancelBookingPopup}>Cancel Booking</button></div>
                    <div className="cal-header p-6">Booking will go ahead!</div>
                </div>
            }
            
            {(infoType === "session" && infoSession?.BookingId !== "" && false) ?
                //implement later
                <div className="p-2">
                    <div className="basic-form-label text-center cal-booking-nohover">Booking</div>
                    <div className="grid grid-cols-4">
                        <div className="cursor-pointer"> <div className="text-center cal-header ">Dec 21</div> {(showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
                        <div className="cursor-pointer"> <div className="text-center cal-header ">Dec 28</div> {(!showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
                        <div className="cursor-pointer"> <div className="text-center cal-header">Jan 4</div> {(!showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
                        <div className="cursor-pointer"> <div className="text-center cal-header">Jan 11</div> {(!showPlanningPanel) ? <div className="border border-t-0 border-r-0 border-l-0 border-b-2 border-blue-500"></div> : <></>}</div>
                    </div>
                    <div className="grow flex flex-row p-2">
                        <div className="text-center cal-header m-4 grow">December 21 -  {info?.Day} {(info?.TimeSlotIndex96 ? minuteIntervals96[info?.TimeSlotIndex96 ?? 0] : "")}</div>
                        <div className="m-2">
                            <button className="primary-button">Cancel Session</button></div>
                    </div>
                </div>
                :
                <></>
            }
        </>)
    }

    const refreshNewBookings = useCallback( async () => {
        await GetAllNewBookings(currentUser?.uid ?? "").then((bookings) => {
            setNewBookings(bookings);
        });
    }, [currentUser]);

    const refreshSessions = useCallback(async () => {
        await GetSessionsForUser(currentUser?.uid ?? "").then((sessions) => {
            setNewSessions(sessions);
        });
    }, [currentUser]);

    const refreshBookings = useCallback(async () => {
        await GetBookingsForUser(currentUser?.uid ?? "").then((bookings) => {
            setBookings(bookings);
        });
    }, [currentUser]);
    useEffect(() => {
        refreshNewBookings();
        refreshSessions();
        refreshBookings();
    }, [refreshNewBookings, refreshSessions, refreshBookings]);

    return (
        <LoggedInLayoutSelector>
            <VerifyLoggedIn />
            {showBookingGuide && <BookingGuide handleCloseTOSModal={handleCloseBookingGuide} />}
            {showSessionGuide && <SessionGuide handleCloseTOSModal={handleCloseSessionGuide} />}
            {showRequestGuide && <RequestGuide handleCloseTOSModal={handleCloseRequestGuide} />}
            {showConfirmCancelBookingPopup && confirmCancelBookingPopup()}
            <div className="main-bg">
                <div className="grid lg:grid-cols-10 max-lg:grid-cols-1 max-h-[calc(100vh-100px)]">
                    <Calendar classNameCss="lg:col-span-7 flex max-h-[calc(100vh-100px)] max-lg:collapse max-lg:max-h-0 lg:mr-2 max-lg:p-0" bookings={bookings} filteredSessions={filteredSessions} onClick={onCalendarClick} showBookings={showBooking} calendarWeek={calendarWeek} setCalendarWeek={setCalendarWeek} />

                    <div className="section-box relative lg:col-span-3  max-lg:grid-cols-1 max-h-[calc(100vh-100px)]  max-lg: min-h-[calc(100vh-100px)]">
                        <div className="absolute-0 p-2 flex flex-col">
                            {(!showInfoPanel) ? renderPlanningPanel() : <></>}
                            {(showInfoPanel) ? renderInfo() : <></>}
                        </div>
                    </div>
                </div>
            </div>
        </LoggedInLayoutSelector>
    );
}